import css from 'styled-jsx/css';

export const staticStyles = css.global`
  .ChangeStatusButtonWarning {
    max-width: 500px;
    padding: 24px;
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 12px;
    border-radius: 8px;
    background: rgba(242, 178, 51, 0.1);

    &__icon-wrapper {
      color: #f2b233;
    }

    span {
      font-size: 14px;
      font-weight: 500;
    }

    &__text-red {
      color: #ee3235;
      text-transform: uppercase;
    }
  }
`;
